export const getAppUser = (state) => {
  return state?.app?.user;
};

export const getAppLanguage = (state) => {
  return state?.app?.lng;
};

export const getModal = (state) => {
  return state?.app?.modal;
};

export const getStateOfConfirmModal = (state) => {
  return state?.app?.stateOfConfirmModal;
};

export const getIsSurveyEditor = (state) => {
  return state?.app?.surveyEditor.isSurveyEditor;
};

export const getIsCommonDialogMode = (state) => {
  return state?.app?.chat.isCommonDialogMode;
};

export const getIsDialogs = (state) => {
  return state?.app?.chat.isDialogs;
};

export const getChatStatus = (state) => {
  return state?.app?.chat.chatStatus;
};

export const getIsCommonDialog = (state) => {
  return state?.app?.isCommonDialog;
};

export const getSelectedDialog = (state) => {
  return state?.app?.chat?.selectedDialog;
};

export const getIsShowMessagesList = (state) => {
  return state?.app?.chat.isShowMessagesList;
};

export const getIsNewMessage = (state) => {
  return state?.app?.chat.isNewMessage;
};

export const getSelectedEntity = (state) => {
  return state?.app?.chat.selectedEntity;
};

export const getCurrentDialog = (state) => {
  return state?.app?.chat.currentDialog;
};

export const getRepliedMessage = (state) => {
  return state?.app?.chat.repliedMessage;
};

export const getDialogIdToDelete = (state) => {
  return state?.app?.chat.dialogIdToDelete;
};

export const getCreatableFile = (state) => {
  return state?.app?.filesManager.creatableFile;
};

export const getIsUpdateFilesList = (state) => {
  return state?.app?.filesManager.isUpdateFilesList;
};

export const getEditableFile = (state) => {
  return state?.app?.filesManager.editableFile;
};

export const getIsSharedFilesMode = (state) => {
  return state?.app?.filesManager.isSharedFilesMode;
};

export const getSharedBreadCrumbs = (state) => {
  return state?.app?.filesManager.sharedBreadCrumbs;
};

export const getPersonalBreadCrumbs = (state) => {
  return state?.app?.filesManager.personalBreadCrumbs;
};

export const getIsSharedFolderMode = (state) => {
  return state?.app?.filesManager.isSharedFolderMode;
};

export const getSharedFolder = (state) => {
  return state?.app?.filesManager.sharedFolder;
};

export const getSelectedFile = (state) => {
  return state?.app?.filesManager.selectedFile;
};

export const getSelectedFiles = (state) => {
  return state?.app?.filesManager.selectedFiles;
};

export const getIsDocReaderShowed = (state) => {
  return state?.app?.filesManager.isDocReaderShowed;
};

export const getIsFilesManagerNoAttachMode = (state) => {
  return state?.app?.filesManager.isFilesManagerNoAttachMode;
};

export const getPersonalFolder = (state) => {
  return state?.app?.filesManager.personalFolder;
};

export const getIsSharedFiles = (state) => {
  return state?.app?.filesManager.isSharedFiles;
};

export const getIsPersonalFiles = (state) => {
  return state?.app?.filesManager.isPersonalFiles;
};

export const getPersonalCourseCategoryFolder = (state) => {
  return state?.app?.filesManager.personalCourseCategoryFolder;
};

export const getIsFilesManager = (state) => {
  return state?.app?.filesManager.isFilesManager;
};

export const getSharedCourseCategoryFolder = (state) => {
  return state?.app?.filesManager.sharedCourseCategoryFolder;
};

export const getIsSurveyEditCreateForm = (state) => {
  return state?.app?.surveyEditor.isSurveyEditCreateForm;
};

export const getIsFilesManagerPersonalFiles = (state) => {
  return state?.app?.filesManager.isPersonalFiles;
};

export const getIsSurveyPreviewMode = (state) => {
  return state?.app?.surveyEditor.isSurveyPreviewMode;
};

export const getSurveyFormTemplateId = (state) => {
  return state?.app?.surveyEditor.surveyFormTemplateId;
};
export const getSurveyFormTemplate = (state) => {
  return state?.app?.surveyEditor.surveyFormTemplate;
};

export const getIsSurveyResetForm = (state) => {
  return state?.app?.surveyEditor.isSurveyResetForm;
};
